import { UserStatus } from "@generated/CurrentUser_Query.graphql";
import { StartTreeConfigType } from "@generated/NavigateDirectToQuestionsAdvanceTreeButton_LearnOpportunityV2Fragment.graphql";
import { selectNoAuthorizedMessageBasedOnGlobalUserStatus } from "./selectNoAuthorizedMessageBasedOnGlobalUserStatus";

export const selectNoAuthorizedMessage = (
	reasonConfigTypes: readonly StartTreeConfigType[] | undefined,
	globalUserStatus: UserStatus | undefined,
) => {
	if (reasonConfigTypes?.includes("StartTree_SpecificUserRolesCan")) {
		return "Ihre Berufsgruppe hat keinen Zugriff auf diesen Inhalt.";
	} else if (reasonConfigTypes?.includes("StartTree_SpecificUserStatusesCan")) {
		return selectNoAuthorizedMessageBasedOnGlobalUserStatus(globalUserStatus);
	} else {
		return "Sie haben keinen Zugriff auf diesen Inhalt.";
	}
};
